module.exports = __webpack_public_path__ + "static/media/baemingo_logo_small.d13e94fa.svg";